import Predicates from 'constants/predicates';
import Types from 'constants/types';

const viewFormatMapping = {
  [Types.SPECTRUM.ACTOR_VIEW]: Predicates.SPECTRUM.ACTOR_FORMAT,
  [Types.SPECTRUM.LOCATION_INFORMATION_VIEW]: Predicates.SPECTRUM.LOCATION_INFORMATION_FORMAT,
  [Types.SPECTRUM.CE.PROPERTY_VIEW]: Predicates.SPECTRUM.CE.PROPERTY_FORMAT,
  [Types.SPECTRUM.CE.BUILDING_VIEW]: Predicates.SPECTRUM.CE.BUILDING_FORMAT,
};

/**
 * 
 * @param {*} format 
 * @returns boolean that indicates whether @param format defines 
 * a resource or an object  
 */
export const isArchivedObjectFormat = (format) => {
  return Object.values(viewFormatMapping).includes(format);
};

/**
 * 
 * @param {*} view 
 * @returns format of an archived object
 */
export const convertViewToFormat = (view) => {
  return viewFormatMapping[view];
};

/**
 * 
 * @param {*} format 
 * @returns view that the archived object belongs to
 */
export const convertFormatToView = (format) => {
  return Object.keys(viewFormatMapping).find(key => viewFormatMapping[key] === format);
};

/**
 * 
 * @param {*} LocaleContext 
 * @param {*} format 
 * @returns view that the archived object belongs lo
 */
export const convertFormatToLocalizedView = (LocaleContext, format) => {
  const view = convertFormatToView(format);
  return view ? LocaleContext.view[view] : '';
};
